import type { ReactNode } from 'react';

/** A compact title for child directories; the content carries the main action. */
export function LearnPageHeading({
  title,
  description,
  aside,
}: {
  title: string;
  description: string;
  aside?: ReactNode;
}) {
  return (
    <header className="mb-6 flex items-center justify-between gap-4">
      <div className="min-w-0">
        <h1 className="text-3xl font-bold text-ink sm:text-4xl">{title}</h1>
        <p className="mt-2 text-ink-soft">{description}</p>
      </div>
      {aside}
    </header>
  );
}
